import React, { useContext, useEffect, useState } from 'react';
import styles from './DashboardPageAppMfg.module.css';
import Chart from "react-google-charts";
import processingVideo from "Assets/processing.mp4";
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import { useSelector } from 'react-redux';
import { getSearchEndDate } from 'Redux/DashboardVariables';
import { getCameraData } from 'Redux/DashboardVariables';
import { getLocationsData } from 'Redux/DashboardVariables';
import { getSearchStartDate } from 'Redux/DashboardVariables';
import { getCameraSelected } from 'Redux/DashboardVariables';
import { getLocationSelected } from 'Redux/DashboardVariables';
import { getWholeData } from 'Redux/DashboardVariables';
import { Avatar, Button, Dialog, DialogActions, DialogContent, DialogTitle, Paper, Typography } from '@mui/material';
import IconStatCard from 'CommonComponents/IconStatCard';
import { isSameDay } from 'HelperFiles/DashboardHelper';
import DoriStackedBarChart from 'CommonComponents/DoriStackedBarChart';
import { getAnalyticSummaryPageData } from 'Redux/DashboardVariables';
import DoriDonutChart from 'CommonComponents/DoriDonutChart';
import VideojsPage from 'CommonComponents/VideojsPage';

const AnalyticsSummary = () => {
  const wholeData = useSelector(getWholeData);
  const searchStartDate = useSelector(getSearchStartDate);
  const searchEndDate = useSelector(getSearchEndDate);
  const {
    barChartData,
    statCardData,
    pieChartData,
    timeLineData,
    videoData
  } = useSelector(getAnalyticSummaryPageData);

  const [videoIndex, setVideoIndex] = useState(-1);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    if (!wholeData.length) {
      setVideoIndex(-1);
    }
  }, [])

  const handleClose1 = () => {
    setOpenModal(false);
  };

  const timeLineChartEvents = [
    {
      eventName: "select",
      callback({ chartWrapper }) {
        let tempVideoIndex = chartWrapper.getChart().getSelection()[0].row;
        // Only enable playback of those events that have snippets
        if (videoData[tempVideoIndex].video !== "") {
          setVideoIndex(tempVideoIndex);
          setOpenModal(true);
        }

      }
    }
  ];

  const MAX_KEY_ANALYTICS_COUNT = 3;
  const cardStyle1 = { padding: "4px 8px", boxShadow: "none" };


  const clearPageData = () => {
    setVideoIndex(-1);
    setOpenModal(false);
  }

  // console.log('main log analytic summary: ', statCardData);

  let displayAvatar = (bgcolor, icon) => {
    return (
      <Avatar sx={{ bgcolor: bgcolor }} aria-label="recipe">
       {icon}
      </Avatar>
    );
  }

  const displayCard = (useCase, index) => {
      return (
      <Paper
        key={useCase.title}
        elevation={0}
        style={{
          padding: '1px 1px',
          background: "transparent",
          width: "33%",
        }}
      >
        <IconStatCard
          title={useCase.title}
          subheader={useCase.subheader}
          body={useCase.body}
          footer={useCase.footer}
          cardStyle={useCase.cardStyle}
          avatar={useCase.avatar}
          footerButtonOnClick={useCase.footerButtonOnClick}
        />
      </Paper>
        );
  }

  // Show a maximum of 6 stat cards
  const [analyticPage, setAnalyticPage] = useState(0)
  const [useCasesDisplay, setUseCasesDisplay] = useState(null);

  useEffect(() => {
    let tempUseCasesDisplay = statCardData
      .slice(MAX_KEY_ANALYTICS_COUNT * analyticPage,
        MAX_KEY_ANALYTICS_COUNT * analyticPage + MAX_KEY_ANALYTICS_COUNT
      ).map((useCase, index) => displayCard(useCase, index));
    setUseCasesDisplay(tempUseCasesDisplay);
  }, [analyticPage, statCardData]);

  let noChartData = displayCard(
    {
      title: "No Hourly/Daily Events",
      body: " ",
      cardStyle: cardStyle1,
      avatar: displayAvatar('orange', <AccessTimeFilledIcon/>),
    }
  );

  let noPieChartData = displayCard(
    {
      title: "No Events",
      body: " ",
      cardStyle: cardStyle1,
      avatar: displayAvatar('orange', <AccessTimeFilledIcon/>),
    }
  );


  let noTimelineEventsDisplay = displayCard(
    {
      title: "No Timeline Events",
      body: " ",
      cardStyle: cardStyle1,
      avatar: displayAvatar('orange', <AccessTimeFilledIcon/>),
    }
  );

  const barChartEventsArr = [
    {
      eventName: "select",
      callback({ chartWrapper }) {
        // console.log('bar chart event: ', chartWrapper.getChart().getSelection());
      }
    }
  ];

  return (
    <>
      <div className={styles.topContainer}>
        <div className={styles.leftColumnContainer} style={{paddingLeft: "0px"}}>
          <div style={{ width:"100%" }}>
            <Paper elevation={0} style={{
              overflow: 'hidden',
              padding: '10px 10px',
              fontSize: "12px",
              color: "#757575",
            }}>
              <div style={{ display: 'flex' }}>
                <div style={{
                  width:"100%",
                  fontFamily: 'Lato, sans-serif',
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center'
                }}>
                  Key Analytics
                </div>
                <div style={{width:"100%", textAlign: "right"}}>
                  <Button
                    onClick={() => setAnalyticPage(analyticPage - 1)}
                    disabled={analyticPage === 0}
                    style={{
                      margin: '0px 5px',
                      color: 'white',
                      backgroundColor: analyticPage === 0 ? 'lightgray' : '#45BF9F',
                      boxShadow: 'none',
                      textTransform: 'none'
                    }}>Prev</Button>
                  <Button
                    onClick={() => setAnalyticPage(analyticPage + 1)}
                    disabled={statCardData.length < MAX_KEY_ANALYTICS_COUNT || 
                      analyticPage === Math.ceil(statCardData.length / MAX_KEY_ANALYTICS_COUNT) - 1}
                    style={{
                      margin: '0px 5px',
                      color: 'white',
                      backgroundColor: (
                        statCardData.length < MAX_KEY_ANALYTICS_COUNT ||
                        analyticPage === Math.ceil(statCardData.length / MAX_KEY_ANALYTICS_COUNT) - 1)
                        ? 'lightgray'
                        : '#45BF9F',
                      boxShadow: 'none',
                      textTransform: 'none'
                    }}>Next</Button>
                </div>
              </div>            
            </Paper>
          </div>
          <div style={{ display: 'flex'}}>
            <div className={styles.topContainerDashboard} style={{margin: "0px 0px 0px 0px", display:"flex", flexWrap:"wrap"}}>
              {useCasesDisplay}
            </div>
          </div>
        </div>
        <div className={styles.rightColumnContainer}>
          <Paper elevation={0} style={{
            overflow: 'hidden',
            padding: '10px 10px',
            height: '100%',
            fontSize: "12px",
            color: "#757575",
          }}>
            <div style={{ display: 'flex', fontFamily: 'Lato, sans-serif', fontSize: '14px' }}>
              <span>
                {
                  isSameDay(searchStartDate, searchEndDate)
                    ? 'Hourly Analysis'
                    : 'Daily Analysis'
                }
              </span>
            </div>            
            {
              barChartData.chartData && barChartData.chartData.length
              ? 
              <DoriStackedBarChart
                chartEvents={barChartEventsArr}
                barChartData={barChartData.chartData}
                chartColors={barChartData.chartColors}
              />
              : 
              <div style={{ display: 'flex', height:"100%", alignItems:"center", justifyContent:"center"}}>
                {noChartData}
              </div>
            }
          </Paper>
        </div>
      </div>
      <div className={styles.topContainer}>
        <div className={styles.leftColumnContainer} style={{paddingLeft: "0px", height:"40vh", width: "40%"}}>
          <Paper elevation={0} style={{
            overflow: 'hidden',
            padding: '10px 10px',
            height: '100%',
            fontSize: "12px",
            color: "#757575",
          }}>
            <div style={{ display: 'flex', fontFamily: 'Lato, sans-serif', fontSize: '14px' }}>
              <span>
                 Analytic Distribution
              </span>
            </div>
            {pieChartData.chartData && pieChartData.chartData.length ? 
              <DoriDonutChart
                height='100%'
                width='100%'
                title=''
                chartData={pieChartData.chartData}
                chartColors={pieChartData.chartColors}
              />
              :
              <div style={{ display: 'flex', height:"100%", alignItems:"center", justifyContent:"center"}}>
                {noPieChartData}
              </div>

            }
          </Paper>
        </div>
        <div className={styles.rightColumnContainer} style={{ margin: '0px 0px', height: "40vh", width: "60%"}}>
          <Paper elevation={0} style={{
            padding: '5px',
            width: '100%',
            height: '100%',
            fontSize: "12px",
            color: "#757575",
            boxSizing: 'border-box'
          }}>
            <div style={{ display: 'flex', marginBottom: '8px', fontSize: '14px', fontFamily: 'Lato, sans-serif' }}>
              <span>
                Timeline Distribution
              </span>&nbsp;
              <span style={{ fontStyle: 'italic', fontWeight: 'normal' }}>(scroll down for more cameras)</span>
            </div>
            {
              timeLineData && timeLineData.length ?
                  <Chart
                    chartEvents={timeLineChartEvents}
                    chartType="Timeline"
                    data={timeLineData}
                    height="35vh"
                    options={{
                      tooltip: { isHtml: true },
                      hAxis: {
                        format: "MMM d, y HH:mm:ss",
                      }
                    }}
                  />
              :
              <div style={{ display: 'flex', height:"100%", alignItems:"center", justifyContent:"center"}}>
                {noTimelineEventsDisplay}
              </div>
            }
          </Paper>
        </div>
      </div>
      <Dialog
          fullWidth={false}
          maxWidth={"md"}
          open={openModal}
          onClose={handleClose1}
          aria-labelledby="max-width-dialog-title"
        >
          <DialogTitle id="customized-dialog-title" onClose={handleClose1}>
            {/* {selectedData ? selectedData.incidentType : ""} */}
            <span
              style={{ textTransform: "inherit!important", color: "#e40000" }}
            >
              {videoIndex !== -1 && videoData[videoIndex]
                ? videoData[videoIndex].incidentLocation +
                  " - " +
                  videoData[videoIndex].incidentCamera +
                  " - " +
                  videoData[videoIndex].incidentType
                : ""}
            </span>
          </DialogTitle>
          <DialogContent dividers style={{ background: "black" }}> 
            <VideojsPage
              src={
                videoIndex !== -1 &&
                videoData[videoIndex] &&
                videoData[videoIndex].video
                  ? videoData[videoIndex].video
                  : processingVideo
              }
              height="auto"
              width="100%"
            />
          </DialogContent>
          
          <DialogActions
            style={{ justifyContent: "space-around" }}
          >
            <Typography style={{ marginRight: "20px" }}>
              {videoIndex !== -1 && videoData[videoIndex]
                ? new Date(videoData[videoIndex].incidentTime).toString()
                : ""}
            </Typography>

            <Button
              variant="contained"
              style={{ background: "#e40000", textTransform: 'none' }}
              color="primary"
              onClick={handleClose1}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
    </>
  );
};


export default AnalyticsSummary;

